import React, { forwardRef } from "react";

const TransformSection = forwardRef(
  (
    {
      imageSrc,
      altText,
      heading,
      paragraph,
      points,
      ticons,
    },
    ref
  ) => {
    return (
      <section
        ref={ref}
        className="relative py-16 md:py-20 bg-[#F7F1EA] overflow-hidden"
      >
        {/* BG GLOWS */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#E8C8A7]/25 blur-3xl rounded-full" />
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#DDBA99]/20 blur-3xl rounded-full" />

        <div className="relative max-w-[1280px] mx-auto px-6">
          {/* Heading */}
          <div className="text-center mb-12">
            <div
              className="
                inline-flex
                items-center
                px-4
                py-2
                rounded-full
                bg-[#FFF4E8]
                border
                border-[#F3DDC7]
                text-primary
                text-[11px]
                tracking-[.18em]
                uppercase
                font-medium
                mb-4
              "
            >
              Your Transformation
            </div>

            <h2
              className="
                text-3xl
                md:text-5xl
                font-bold
                text-secondary
                leading-tight
              "
            >
              {heading}
            </h2>
          </div>

          {/* Main Grid */}
          <div
            className="
              grid
              grid-cols-1
              lg:grid-cols-2
              gap-8
              items-stretch
              lg:min-h-[760px]
            "
          >
            {/* IMAGE */}
            <div
              className="
                group
                relative
                overflow-hidden
                rounded-[34px]
                h-full
                min-h-[760px]
                shadow-[0_25px_60px_rgba(20,10,0,.10)]
              "
            >
              <img
                src={imageSrc}
                alt={altText}
                className="
                  w-full
                  h-full
                  object-cover
                  transition-transform
                  duration-700
                  group-hover:scale-105
                "
              />

              <div
                className="
                  absolute
                  inset-0
                  bg-gradient-to-t
                  from-black/80
                  via-black/20
                  to-transparent
                "
              />

              {/* Floating Content */}
              <div className="absolute bottom-6 left-6 right-6">
                <div
                  className="
                    rounded-[28px]
                    bg-white/10
                    backdrop-blur-2xl
                    border
                    border-white/10
                    p-6
                  "
                >
                  <h3
                    className="
                      text-2xl
                      md:text-3xl
                      font-bold
                      text-white
                      mb-3
                    "
                  >
                    Thrive Beyond Survival
                  </h3>

                  <p
                    className="
                      text-white/75
                      text-sm
                      leading-7
                    "
                  >
                    Sustainable wellbeing,
                    resilience, emotional
                    strength, and deep inner
                    clarity for long-lasting
                    transformation.
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="flex flex-col h-full gap-4">
              {points.map((point, index) => (
                <div
                  key={index}
                  className="
                    flex-1
                    relative
                    overflow-hidden
                    rounded-[28px]
                    bg-white/75
                    backdrop-blur-xl
                    border
                    border-white/40
                    shadow-[0_15px_40px_rgba(20,10,0,.05)]
                    p-5
                    transition-all
                    duration-500
                    hover:-translate-y-1
                  "
                >
                  <div
                    className="
                      absolute
                      top-0
                      right-0
                      w-32
                      h-32
                      bg-[#F4D8BE]/20
                      blur-3xl
                      rounded-full
                    "
                  />

                  <div className="relative z-10 flex items-start gap-4">
                    <div
                      className="
                        w-12
                        h-12
                        rounded-full
                        bg-[#FFF4E8]
                        border
                        border-[#F3DDC7]
                        flex
                        items-center
                        justify-center
                        text-xl
                        shrink-0
                      "
                    >
                      {ticons[index] || ticons[0]}
                    </div>

                    <div className="flex-1">
                      <div
                        className="
                          text-sm
                          md:text-base
                          leading-7
                          text-[#4F463F]
                        "
                      >
                        {point}
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Bottom CTA Card */}
              {paragraph && (
                <div
                  className="
                    mt-auto
                    relative
                    overflow-hidden
                    rounded-[28px]
                    bg-secondary
                    p-6
                    shadow-[0_20px_60px_rgba(20,10,0,.12)]
                  "
                >
                  <div
                    className="
                      absolute
                      top-0
                      right-0
                      w-48
                      h-48
                      bg-[#D8B08B]/10
                      blur-3xl
                      rounded-full
                    "
                  />

                  <p
                    className="
                      relative
                      z-10
                      text-white/90
                      text-sm
                      md:text-base
                      leading-7
                    "
                  >
                    {paragraph}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
);

TransformSection.displayName = "TransformSection";

export default TransformSection;